export const YOUTUBE_SCRIPT_NAME = 'youtube';
export const YOUTUBE_SCRIPT_URL = 'https://www.youtube.com/player_api';
